/* eslint-disable import/no-unresolved */
/* eslint-disable global-require */
import { combineReducers } from 'redux';

export default combineReducers({
  // auth: require('./auth/reducer').reducer,
  blast: require('wao-react-shared-components/src/components/blast/model/reducer').reducer,
  deals: require('wao-react-shared-components/src/components/deals/model/reducer').reducer,
  orders: require('wao-react-shared-components/src/components/orders/model/reducer').reducer,
  users: require('wao-react-shared-components/src/components/users/model/reducer').reducer,
  referrers: require('wao-react-shared-components/src/components/referrers/model/reducer').reducer,
  customers: require('wao-react-shared-components/src/components/customers/model/reducer').reducer,
  groups: require('wao-react-shared-components/src/components/groups/model/reducer').reducer,
  workflow: require('wao-react-shared-components/src/core/models/workflow/reducer').reducer,
  commissions: require('wao-react-shared-components/src/components/commissions/model/reducer').reducer,
  promotions: require('wao-react-shared-components/src/components/promotions/model/reducer').reducer,
  products: require('wao-react-shared-components/src/components/products/model/reducer').reducer,
  categories: require('wao-react-shared-components/src/core/models/categories/reducer').reducer,
  recomendations: require('wao-react-shared-components/src/components/recomendations/model/reducer').reducer,
  // serviceWorker: require('./serviceWorker/reducer').reducer,
});
